import i18n from '../i18n/config';

/**
 * Nationality'ye göre dil ayarlar
 * @param {string} nationality - Ülke adı (örn: "Turkey", "France")
 * @returns {string} - Dil kodu (tr, fr, en)
 */
export const getLanguageFromNationality = (nationality) => {
  if (!nationality) {
    return 'en'; // Varsayılan İngilizce
  }

  const nationalityLower = nationality.toLowerCase().trim();

  // Turkey → Türkçe
  if (nationalityLower === 'turkey' || nationalityLower === 'türkiye') {
    return 'tr';
  }

  // France → Fransızca
  if (nationalityLower === 'france') {
    return 'fr';
  }

  // Diğer tüm ülkeler → İngilizce
  return 'en';
};

/**
 * Nationality'ye göre i18n dilini ayarlar
 * @param {string} nationality - Ülke adı (örn: "Turkey", "France")
 * @param {boolean} force - Zorla ayarla (manuel tercihi yok say)
 */
export const setLanguageFromNationality = (nationality, force = false) => {
  // Eğer kullanıcı manuel dil seçmişse ve force=false ise, nationality'ye göre ayarlama
  if (!force && localStorage.getItem('languageManuallySet') === 'true') {
    return; // Manuel tercih korunur
  }

  const language = getLanguageFromNationality(nationality);
  i18n.changeLanguage(language);
  // localStorage'a da kaydet
  localStorage.setItem('i18nextLng', language);
  // Nationality'ye göre ayarlandığı için manuel flag'i temizle (sadece force=true ise)
  if (force) {
    localStorage.removeItem('languageManuallySet');
  }
};

/**
 * localStorage'dan doctor veya tenant nationality'sini alıp dil ayarlar
 * Manuel dil tercihi varsa atlar
 */
export const setLanguageFromStoredNationality = () => {
  // Eğer kullanıcı manuel dil seçmişse, nationality'ye göre ayarlama
  if (localStorage.getItem('languageManuallySet') === 'true') {
    return; // Manuel tercih korunur
  }

  // Önce doctor bilgisini kontrol et
  const userStr = localStorage.getItem('user');
  if (userStr) {
    try {
      const user = JSON.parse(userStr);
      if (user.nationality) {
        setLanguageFromNationality(user.nationality);
        return;
      }
    } catch (e) {
      console.error('Error parsing user data:', e);
    }
  }

  // Sonra tenant bilgisini kontrol et
  const tenantInfoStr = localStorage.getItem('tenantInfo');
  if (tenantInfoStr) {
    try {
      const tenantInfo = JSON.parse(tenantInfoStr);
      if (tenantInfo.nationality) {
        setLanguageFromNationality(tenantInfo.nationality);
        return;
      }
    } catch (e) {
      console.error('Error parsing tenant info:', e);
    }
  }

  // Eğer hiçbir nationality bulunamazsa, mevcut dil ayarını koru
  // (browser diline göre zaten ayarlanmış olabilir)
};
